let MANIFEST_URL = null;
try {
  // eslint-disable-next-line no-undef
  MANIFEST_URL = ENV_MANIFEST_URL;
} catch (e) {
  MANIFEST_URL = "https://localhost:44301";
}

const DEFAULT_DEV_LOGIN_ROLES = [
  "Trailer Board",
  "Dispatch",
  "Drivers",
  "JDM Barcoding",
  "Yard Security",
  "Yard Spot",
  "Yard Exec Summary",
  "Manifest Billing",
  "Manifest Clerk",
  "VaxAdmin",
  "VaxSupervisor",
  "Export Inventory",
  "Inventory Management",
  "Quad City Freight Service, Inc",
  "Fork Truck Audit",
];

const DEFAULT_DEV_LOGIN_USER = "devuser@qcfs.local";

function readRaw(readToken, envFallback) {
  try {
    return readToken();
  } catch (e) {
    return envFallback;
  }
}

function isEnabled(raw) {
  return raw === true || raw === "true" || raw === "1" || raw === 1;
}

function parseRoles(raw) {
  if (raw == null || String(raw).trim() === "") {
    return DEFAULT_DEV_LOGIN_ROLES.slice();
  }
  return String(raw)
    .split("|")
    .map((role) => role.trim())
    .filter((role) => role.length > 0);
}

function parseUser(raw) {
  if (raw == null || String(raw).trim() === "") {
    return DEFAULT_DEV_LOGIN_USER;
  }
  return String(raw).trim();
}

const devLoginEnabled = isEnabled(
  readRaw(function () {
    // eslint-disable-next-line no-undef
    return DEV_LOGIN_ENABLED;
  }, process.env.VUE_APP_DEV_LOGIN),
);

const devLoginRoles = parseRoles(
  readRaw(function () {
    // eslint-disable-next-line no-undef
    return DEV_LOGIN_ROLES;
  }, process.env.VUE_APP_DEV_LOGIN_ROLES),
);

const devLoginUser = parseUser(
  readRaw(function () {
    // eslint-disable-next-line no-undef
    return DEV_LOGIN_USER;
  }, process.env.VUE_APP_DEV_LOGIN_USER),
);

if (devLoginEnabled) {
  console.warn(
    `Dev login is on. The session signs in as ${devLoginUser} with ${devLoginRoles.length} roles and does not contact Entra.`,
  );
}

export { MANIFEST_URL, devLoginEnabled, devLoginRoles, devLoginUser };
